<template>
	<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<g filter="url(#filter0_i)">
			<path d="M4.40803 8.91045L1.54439 5.77612L0.589844 6.8209L4.40803 11L12.5898 2.04478L11.6353 1L4.40803 8.91045Z" :fill="fill_color" :fill-opacity="opacity"/>
		</g>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>